import { BasicCard, Button, H4 } from "@template/components";
import * as S from "./styles.ts";
import { useTypedSelector } from "@/redux/helpers/hooks.ts";
import CartItem from "@/template/blocks/NavigationSection/component/NavAuth/CartControl/CartDropdown/CartItem/index.tsx";

const Header = () => {
  const { user } = useTypedSelector((state) => state.user);
  const voip = user?.voip;

  const isVoipAdded =
    (voip?.has_voip_cart_users && voip?.has_voip_cart) ||
    (voip?.has_voip_customer && !voip?.has_voip_trial) ||
    user?.has_voip;

  return (
    <S.HeaderContainer>
      <H4>Phone Numbers To Port</H4>
      {isVoipAdded ? (
        <Button
          size="md"
          navigation={{ href: "/shopping-cart" }}
          title="Click to go to checkout"
        >
          Checkout
        </Button>
      ) : (
        <Button
          size="md"
          navigation={{ href: "/voice" }}
          title="Click to go choose a voice plan"
        >
          Choose Plan
        </Button>
      )}
    </S.HeaderContainer>
  );
};

const CartItems = () => {
  const { cart } = useTypedSelector((state) => state.user);

  return (
    <S.CartItemsContainer>
      {cart.items
        .filter((item) => item.type.id === 15)
        .map((item) => (
          <CartItem
            item={item}
            key={item.id}
            billing_interval={cart?.billing_interval}
          />
        ))}
    </S.CartItemsContainer>
  );
};

const TransfersInCart = () => {
  const { cart } = useTypedSelector((state) => state.user);

  if (cart.items.filter((item) => item.type.id === 15).length === 0) {
    return;
  }

  return (
    <BasicCard>
      <Header />
      <CartItems />
    </BasicCard>
  );
};

export default TransfersInCart;
